<script lang="ts">
  import type { Object3D, Object3DEventMap } from 'three'
  import TranslationInput from '../../../../../components/translation-input/TranslationInput.svelte'
  import ControlGroup from '../../../../../components/control-group/ControlGroup.svelte'
  import ControlGroupContent from '../../../../../components/control-group/ControlGroupContent.svelte'
  import InputLabel from '../InputLabel.svelte'

  type Axis = 'x' | 'y' | 'z'

  type TransformBase = {
    object: Object3D<Object3DEventMap>
    title: string
    unit?: string
    getValue: (obj: Object3D<Object3DEventMap>, axis: Axis) => number
    setValue: (
      obj: Object3D<Object3DEventMap>,
      axis: Axis,
      value: number,
    ) => void
    getLocked: (obj: Object3D<Object3DEventMap>, axis: Axis) => boolean
    setLocked: (
      obj: Object3D<Object3DEventMap>,
      axis: Axis,
      value: boolean,
    ) => void
    convertToDisplay?: (value: number) => number
    convertFromDisplay?: (value: number) => number
  }

  const {
    object,
    title,
    unit = '',
    getValue,
    getLocked,
    setLocked,
    setValue,
    convertToDisplay = (v: number) => v,
    convertFromDisplay = (v: number) => v,
  }: TransformBase = $props()

  let x = $derived(convertToDisplay(getValue(object, 'x')))
  let y = $derived(convertToDisplay(getValue(object, 'y')))
  let z = $derived(convertToDisplay(getValue(object, 'z')))

  let getLockedX = $derived(getLocked(object, 'x'))
  let getLockedY = $derived(getLocked(object, 'y'))
  let getLockedZ = $derived(getLocked(object, 'z'))

  // function isMixed(axis: 'x' | 'y' | 'z') {
  //   if (!hasMultiplePrinters) return false
  //   return printers.some(
  //     printer => getValue(printer, axis) !== getValue(printers[0], axis),
  //   )
  // }

  function handleArrowPressed(axis: 'x' | 'y' | 'z', newValue: number) {
    // if (hasMultiplePrinters) return
    // const currentValue = convertToDisplay(getValue(object, axis))
    setValue(object, axis, newValue)
  // const delta = convertFromDisplay(newValue - currentValue)

    // printers.forEach((printer) => {
    // const current = getValue(printer, axis)
    // setValue(printer, axis, current + delta)
    // })
  }

  function handleType(axis: 'x' | 'y' | 'z', newValue: number) {
    setValue(object, axis, convertFromDisplay(newValue))
  // printers.forEach((printer) => {
    //   setValue(printer, axis, convertFromDisplay(newValue))
    // })
  }

  function onLockChange(axis: Axis, newValue: boolean) {
    setLocked(object, axis, newValue)
  // printers.forEach((printer) => {
    //   setLocked(printer, axis, newValue)
    // })
  }
</script>

<ControlGroup>
  <InputLabel>{title}</InputLabel>
  <ControlGroupContent>
    <!-- to add when putting back multi select
      isLockable={!hasMultiplePrinters}
      hasMultipleValues={hasMultiplePrinters}
      isMixed={isMixed('x')} -->
    <TranslationInput
      name="translation-x"
      defaultValue={x}
      isLockable
      isLocked={getLockedX}
      label="X"
      onLockChange={newValue => onLockChange('x', newValue)}
      onarrowpressed={v => handleArrowPressed('x', v)}
      ontype={v => handleType('x', v)}
      {unit}
    />
    <TranslationInput
      name="translation-y"
      defaultValue={y}
      isLockable
      isLocked={getLockedY}
      label="Y"
      onLockChange={newValue => onLockChange('y', newValue)}
      onarrowpressed={v => handleArrowPressed('y', v)}
      ontype={v => handleType('y', v)}
      {unit}
    />
    <TranslationInput
      name="translation-z"
      defaultValue={z}
      isLockable
      isLocked={getLockedZ}
      label="Z"
      onLockChange={newValue => onLockChange('z', newValue)}
      onarrowpressed={v => handleArrowPressed('z', v)}
      ontype={v => handleType('z', v)}
      {unit}
    />
  </ControlGroupContent>
</ControlGroup>
